import Base from '../Pages/Base'
import List from '../Pages/List'

export default [
	{
		path: 'sistema/destaques',
		component: Base,
		children: [
			{
				path: '',
				name: 'Destaquesist',
				component: List,
				meta: {
					path: '/sistema/destaques',
					pai: 'Sistema',
					title: 'Admin - Destaques',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Destaques',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]